const BombardierLogo = props => {
  return (
    <svg
      version='1.1'
      id='Layer_1'
      xmlns='http://www.w3.org/2000/svg'
      x='0px'
      y='0px'
      width={props.width ? props.width : '196'}
      height={props.height ? props.height : '25'}
      viewBox='6 9 103 15'
      style={{ enableBackground: 'new 0 0 114 35' }}
    >
      <g>
        <g>
          <path
            d='M6.7,9.8h5.2c2.5,0,3.6,1.3,3.6,3.3c0,1.4-0.6,2.7-2.1,3v0c1.7,0.2,2.4,1.6,2.4,3c0,2.3-1.1,3.9-4,3.9H6.7V9.8z M10.2,15
			H11c0.7,0,1.1-0.6,1.1-1.3c0-0.7-0.4-1.4-1.1-1.4h-0.8V15z M10.2,20.6h1c0.6,0,1.2-0.6,1.2-1.6c0-1-0.6-1.6-1.2-1.6h-1V20.6z'
          />
          <path
            d='M21.6,9.6c3.5,0,4.7,1.9,4.7,6.9c0,5-1.2,6.9-4.7,6.9c-3.5,0-4.7-1.9-4.7-6.9C16.9,11.5,18.1,9.6,21.6,9.6z M21.6,21
			c1.1,0,1.2-1,1.2-4.5c0-3.6-0.1-4.5-1.2-4.5c-1.1,0-1.2,1-1.2,4.5C20.4,20,20.6,21,21.6,21z'
          />
          <path d='M27.6,9.8h4.9l1.4,7.8h0l1.4-7.8h4.9V23h-3.2v-9.9h0L35.2,23h-2.5l-1.8-9.9h0V23h-3.2V9.8z' />
          <path
            d='M41.8,9.8H47c2.5,0,3.6,1.3,3.6,3.3c0,1.4-0.6,2.7-2.1,3v0c1.7,0.2,2.5,1.6,2.5,3c0,2.3-1.1,3.9-4,3.9h-5.2V9.8z M45.3,15
			h0.8c0.7,0,1.1-0.6,1.1-1.3c0-0.7-0.4-1.4-1.1-1.4h-0.8V15z M45.3,20.6h1c0.6,0,1.2-0.6,1.2-1.6c0-1-0.6-1.6-1.2-1.6h-1V20.6z'
          />
          <path d='M54.4,9.8h4.3L62,23h-3.7L58,20.7h-2.7L54.9,23h-3.7L54.4,9.8z M56.6,12.5L56.6,12.5l-1,5.6h1.9L56.6,12.5z' />
          <path
            d='M62.9,9.8h5.4c2.6,0,3.6,1.5,3.6,3.5c0,1.8-0.7,2.9-2.3,3.2v0c1.7,0.1,2.2,1.2,2.2,3v1.1c0,0.7,0,1.6,0.2,1.8
			c0.1,0.1,0.2,0.3,0.4,0.4V23h-3.7c-0.3-0.7-0.3-2-0.3-2.5v-0.9c0-1.5-0.3-1.9-1.1-1.9h-0.9V23h-3.4V9.8z M66.4,15.4h0.7
			c1,0,1.4-0.6,1.4-1.6c0-1.1-0.4-1.5-1.5-1.5h-0.7V15.4z'
          />
          <path
            d='M73.4,9.8h5c4,0,4.2,3.2,4.2,6.6c0,3.5-0.2,6.6-4.2,6.6h-5V9.8z M76.9,20.6h0.7c1.3,0,1.5-0.6,1.5-4.1
			c0-3.6-0.2-4.1-1.5-4.1h-0.7V20.6z'
          />
          <path d='M84,9.8h3.4V23H84V9.8z' />
          <path d='M89,9.8h7.8v2.8h-4.4v2.3h4.1v2.7h-4.1v2.6H97V23h-8V9.8z' />
          <path
            d='M98.3,9.8h5.4c2.6,0,3.6,1.5,3.6,3.5c0,1.8-0.7,2.9-2.3,3.2v0c1.7,0.1,2.2,1.2,2.2,3v1.1c0,0.7,0,1.6,0.2,1.8
			c0.1,0.1,0.2,0.3,0.4,0.4V23h-3.7c-0.3-0.7-0.3-2-0.3-2.5v-0.9c0-1.5-0.3-1.9-1.1-1.9h-0.9V23h-3.4V9.8z M101.7,15.4h0.7
			c1,0,1.4-0.6,1.4-1.6c0-1.1-0.4-1.5-1.5-1.5h-0.7V15.4z'
          />
        </g>
      </g>
    </svg>
  )
}
export default BombardierLogo
